import { color, chart, space, radius, fontSize } from './tokens';

/** 스타일 파일이 조회하는 단일 진입점. 토큰 직접 import 대신 이 객체 경유. */
export const theme = { color, chart, space, radius, fontSize } as const;

export type Theme = typeof theme;
/** 레이아웃 프리미티브 gap props에 활용. */
export type SpaceKey = keyof typeof space;
